import { cn } from '@/utils/cn';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
}

const sizeMap = {
  sm: 'w-6 h-6',      // 24px
  md: 'w-8 h-8',      // 32px
  lg: 'w-10 h-10',    // 40px
  xl: 'w-20 h-20',    // 80px
  '2xl': 'w-24 h-24', // 96px
};

export function Logo({ size = 'md', className }: LogoProps) {
  return (
    <div
      className={cn(
        'rounded-lg bg-black flex items-center justify-center',
        sizeMap[size],
        className
      )}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 100 100"
        fill="none"
        className="w-[70%] h-[70%]"
      >
        <text
          x="50"
          y="50"
          dominantBaseline="central"
          textAnchor="middle"
          fill="white"
          fontFamily="Inter, system-ui, sans-serif"
          fontWeight="700"
          fontSize="72"
        >
          G
        </text>
      </svg>
    </div>
  );
}
